/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filter_menu': {
    width: 4,
    height: 17,
    viewBox: '0 0 4 17',
    data: '<g transform="translate(.5 .5)" _fill="#234357" fill-rule="evenodd"><circle pid="0" cx="1.5" cy="1.5" r="1.5"/><circle pid="1" cx="1.5" cy="8" r="1.5"/><circle pid="2" cx="1.5" cy="15" r="1.5"/></g>'
  }
})
